import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";
import WOW from 'wowjs';
import { FaAngleUp } from "react-icons/fa";

import HomeDefault from "./pages/HomeDefault";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import 'swiper/css/effect-fade';

/**
 * AgricHub only needs one informational page pointing people at the store,
 * the vendor application, the farmer portal and the app — the rest of this
 * template's pages (home-two/three, about, services, arbor-management,
 * blog, team, portfolio, contact, faq) were never linked from the live
 * nav (it rendered empty) and aren't routed here, though the files are
 * untouched on disk if any of that content is wanted later.
 *
 * The /signup route is gone outright, per the brief — account creation now
 * happens in the store and the app, not through a standalone onboarding
 * form. Every button that used to point there now points at the real place
 * that job happens today.
 */
function App() {
  useEffect(() => {
    new WOW.WOW({
        live: false
      }).init();
    }, []
  );
  return (
    <Router>
        <Routes>
            <Route path={`${process.env.PUBLIC_URL}/`} exact element={<HomeDefault />} />
            <Route path="*" element={<Navigate to={`${process.env.PUBLIC_URL}/`} replace />} />
        </Routes>
        <ScrollToTop className="scrollUp" smooth top="1500" component={<FaAngleUp />} />
    </Router>
  );
}

export default App;
